<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Article Categories
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Category</vs-button>
        </h3>
        <p class="card-subtitle">List of Article Categories.</p>
        <vs-row>
          <div style="display: flex; align-items: center; gap: 0.5rem">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData()">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>

            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" @change="searchData()">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>

            <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>

            <vs-select :color="colorx" label="Page Limit" v-model="limit" @change="searchData()">
              <vs-select-item value="25" text="25" />
              <vs-select-item value="50" text="50" />
              <vs-select-item value="100" text="100" />
            </vs-select>

            <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
              icon="search">Search</vs-button> -->
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()" style="width: 12%">Reset</vs-button>
            <vs-button color="success" type="filled" class="searchBtn" icon="sort" @click="sortPositions()" style="width: 12%">Sort</vs-button>
          </div>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Category Name</th>
            <th @click="sortBy('position')" style="cursor: pointer">
              Position
              <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Language</th>
            <th @click="sortBy('status')" style="cursor: pointer">
              Status
              <span v-if="sortByField === 'status'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th class="text-center" @click="sortBy('totalViewCount')" style="cursor: pointer">
              Total Views
              <span v-if="sortByField === 'totalViewCount'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Action</th>
            <!-- <th>Guid</th> -->
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td>{{ index + 1 + (currentPage - 1) * limit }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.name }}</td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <vs-button icon="arrow_upward" size="small" @click="updatePosition(item._id, search.sort === 'ASC' ? 'up' : 'down')"></vs-button>
                {{ item.position }}
                <vs-button icon="arrow_downward" size="small" @click="updatePosition(item._id, search.sort === 'ASC' ? 'down' : 'up')"></vs-button>
              </div>
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td class="td d-flex align-items-center justify-content-center">
              <vs-button style="width: 60px" color="primary" type="filled" class="searchBtn"> {{ item.totalViewCount }}</vs-button>
            </td>
            <td class="td">
              <vs-checkbox v-model="item.disableForAll" @change="updateStatus(item._id, item.disableForAll)"> Disable All Category</vs-checkbox>
            </td>
            <!-- <td class="td">{{ item.guid }}</td> -->

            <td class="td">
              <vs-button class="mr15 mt-1" icon="create" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button
                class="mr15 mt-1"
                size="small"
                color="danger"
                icon="delete_sweep"
                @click="
                  deleteCategoryPopup = true;
                  itemToDelete = item;
                "
              >
                Delete
              </vs-button>
              <vs-button class="mr15 mt-1" size="small" color="primary" icon="visibility" @click="viewAll(item)"> View All Articles </vs-button>
              <!-- <vs-button
                class="mr15 mt-1"
                size="small"
                color="primary"
                icon="content_copy"
                @click="copyGuid(item.guid)"
              >
                Copy
              </vs-button> -->
              <!-- <vs-button class="mr15 mt-1" size="small" color="success"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
            </td>
          </tr>
        </table>
        <!-- pagination -->
        <vs-pagination v-model="currentPage" :total="totalPages" :limit="limit" @change="searchData" class="my-4" />

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Category' : clone ? 'Duplicate Category' : 'Edit Category'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Category Language"
                @change="fileterusingLanguage($event, cat)"
                v-model="cat.language"
                icon="arrow_downward"
                :disabled="isNew == true || clone == true"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="item.culture" />
              </vs-select>
            </vs-col>

            <vs-col vs-lg="6" vs-xs="6">
              <vs-button class="mr15 mt-1" size="small" color="primary" icon="content_copy" @click="copyGuid(cat.guid)"> Copy </vs-button>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Category Name (Keep it Simple and short)" v-model="cat.name" />
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Category Position (Try to assign different position)"
                v-model="cat.position" />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
              <p class="mt-2" style="font-size: 0.85rem">Current Position: {{ cat.position }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.moveTop" @change="cat.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.moveBottom" @change="cat.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <uploader
                label="Category File (Try to use square image)"
                v-model="cat.image"
                :file="cat.image"
              />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="!displayImage">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Category File (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12">
              <vs-button icon="save" @click="btnAddCategory">{{ isNew ? "Save English" : "Update one" }}</vs-button>
              <!-- show if not new and update and translate -->
              <vs-button icon="save" class="ml-3" @click="createAndTranslate" v-if="isNew">Save and Translate</vs-button>
              <!-- show only if language is english -->
              <vs-button icon="save" class="ml-3" @click="createAndTranslate" v-if="!showLoader && !isNew && cat.language == 'EN'"
                >Update all</vs-button
              >
              <vs-checkbox v-model="cat.translate" class="ml-3 mt-2" v-if="!isNew && cat.language == 'EN'"> Update translations </vs-checkbox>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Category" :active.sync="deleteCategoryPopup">
          <p>Are you sure you want to delete Category?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteCategory">Delete Category</vs-button>
            <vs-button icon="clear" @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";

import api from "@/rest.js";
import { API } from "@/common/constants";
import Vue from "vue";
import VPopover from "vue-js-popover";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "Article-Category",
  components: {
    // uploader,
  },
  data: () => ({
    title: "Category",
    colorx: "#0D2144",
    defaultalert: false,
    deleteCategoryPopup: false,
    disableCategoryPopup: false,
    isNew: true,
    clone: false,
    displayImage: "",
    sortDirection: "asc",
    sortByField: "",
    fileName: "",
    limit: 25,
    currentPage: 1,
    totalPages: 0,
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
    },
    cat: {
      status: true,
      language: "",
      position: "",
      name: "",
      image: "",
      moveTop: false,
      moveBottom: false,
      translate: false,
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    showLoader: false,
  }),
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.all.sort((a, b) => {
          if (this.sortDirection === "asc") {
            return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
          } else {
            return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
          }
        });
      }
      return this.all;
    },
  },
  watch: {
    "search.language": function (newLang, oldLang) {
      if (newLang !== oldLang) {
        this.currentPage = 1;
      }
    },
    "search.sort": function (newSort, oldSort) {
      if (newSort !== oldSort) {
        this.currentPage = 1;
      }
    },
    "search.status": function (newStatus, oldStatus) {
      if (newStatus !== oldStatus) {
        this.currentPage = 1;
      }
    },
    limit: function (newLimit, oldLimit) {
      if (newLimit !== oldLimit) {
        this.currentPage = 1;
      }
    },
    "cat.moveTop"(newValue) {
      if (newValue) {
        this.cat.moveBottom = false;
      }
    },
    "cat.moveBottom"(newValue) {
      if (newValue) {
        this.cat.moveTop = false;
      }
    },
  },
  methods: {
    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },

    sortPositions() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.ARTICLE_SORT_POSITION}?language=${this.$data.search.language}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Sorted Successfully",
              color: "success",
              position: "top-right",
            });
            this.searchData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    updatePosition(id, type) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.ARTICLE_UPDATE_POSITION}/${id}?direction=${type}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Position Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.searchData();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.response.data.error,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.cat = {
        status: true,
        language: "EN",
        position: "",
        name: "",
        image: "",
        moveBottom: true,
        moveTop: false,
      };
      this.$data.displayImage = "";
    },
    editingItem(i, data) {
      this.$data.clone = data == "clone" ? true : false;
      this.$data.displayImage = i.image;
      this.$data.cat = Object.assign({}, i);
      this.$data.isNew = false;
      this.$data.defaultalert = true;
    },
    btnAddCategory() {
      this.$data.cat.image = this.$data.displayImage;
      if (!this.$data.cat.language || !this.$data.cat.name || !this.$data.cat.image) {
        this.$vs.notify({
          text: "Please enter all fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      let apiToCall = API.ARTICLE_CATEGORY;
      let data = this.$data.cat;

      if (!this.$data.isNew && !this.$data.clone) {
        apiToCall = API.ARTICLE_CATEGORY;
        data["image"] = this.$data.displayImage;
        api
          .put(apiToCall + "?id=" + data._id, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.data.status) {
              this.$vs.notify({
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              (this.$data.cat = {
                status: true,
                language: "",
                position: "",
                name: "",
                image: "",
              }),
                this.searchData();
            } else {
              // this.$vs.notify({
              //   title: "Error",
              //   text: r.data.error,
              //   color: "danger",
              //   position: "top-right",
              // });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
        this.$data.defaultalert = false;
        return;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        this.$data.displayImage = "";
      }
      if (this.$data.clone) {
        apiToCall = API.ARTICLE_CATEGORY;

        data = {
          name: this.$data.cat.name,
          position: this.$data.cat.position,
          language: this.$data.cat.language,
          status: this.$data.cat.status,
          image: this.$data.cat.image,
        };
      }
      api
        .post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
            }),
              this.searchData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    async createAndTranslate() {
      this.$data.cat.image = this.$data.displayImage;
      if (!this.$data.cat.language || !this.$data.cat.name || !this.$data.cat.image) {
        this.$vs.notify({
          text: "Please enter all fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      let apiToCall = API.ARITCLE_CATEGORY_CANDT;
      let data = this.$data.cat;
      this.$data.showLoader = true;

      if (!this.$data.isNew && !this.$data.clone) {
        apiToCall = API.ARTICLE_CATEGORY_UANDT;
        data["image"] = this.$data.displayImage;
        data.translate = this.$data.cat.translate;
        this.$data.defaultalert = false;
        const res1 = await api.put(apiToCall + "?id=" + data._id, data, { headers });
        try {
          if (res1.status === 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
            }),
              this.searchData();

            this.$data.showLoader = false;
            this.$data.defaultalert = false;
            return;
          }
        } catch (error) {
          this.$data.showLoader = false;
          this.$vs.notify({
            title: "Error",
            text: error,
            color: "danger",
            position: "top-right",
          });
          throw new Error(error);
        }
      }

      if (!this.$data.isNew && !this.$data.clone) {
        this.$data.displayImage = "";
      }
      if (this.$data.clone) {
        apiToCall = API.ARTICLE_CATEGORY;

        data = {
          name: this.$data.cat.name,
          position: this.$data.cat.position,
          language: this.$data.cat.language,
          status: this.$data.cat.status,
          image: this.$data.cat.image,
        };
      }

      this.$data.showLoader = true;
      this.$data.defaultalert = false;
      const res = await api.post(apiToCall, data, { headers });
      try {
        this.$vs.loading.close();
        if (res.status == 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          (this.$data.cat = {
            status: true,
            language: "",
            position: "",
            name: "",
            image: "",
          }),
            this.searchData();
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$data.showLoader = false;
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
      }
    },
    fetchAllCategory() {
      this.$vs.loading();
      api
        .get(API.ARTICLE_CATEGORY, {})
        .then((r) => {
          this.$vs.loading.close();
          for (const item of r.data.data) {
            item.tooltipContent =
              item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
          }
          this.$data.all = r.data.data;
        })
        .catch(() => {});
    },
    deleteCategory() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(API.ARTICLE_CATEGORY + "?id=" + this.$data.itemToDelete._id, {}, { headers })

        .then((r) => {
          if (r.data.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteCategoryPopup = false;
          this.searchData();
        })
        .catch(() => {});
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    async searchData() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      try {
        this.$vs.loading();

        const page = !isNaN(this.currentPage) && this.currentPage > 0 ? this.currentPage : 1;

        const res = await api.get(`${API.ARTICLE_CATEGORY}/dash`, {
          headers,
          params: {
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            status: this.$data.search.status,
            page: page,
            limit: this.limit,
          },
        });

        this.$vs.loading.close();
        if (res.status === 200) {
          this.$data.all = res.data.data;
          this.totalPages = Math.ceil(res.data.totalNumber / this.limit);
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
      }
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("category", this.$data.cat.name);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
      };
      this.searchData();
    },
    fileterusingLanguage(event, item) {
      // if (event == "EN") {
      //   return;
      // }

      let id = item.ref || item._id;
      if (event && id) {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        this.$vs.loading();
        api
          .get(API.ARTICLE_CATEGORY + "/" + id, {
            headers,
            params: {
              language: event,
            },
            // params: {
            //   language: this.$data.search.language,
            //   pageSize: this.$data.pageSize,
            //   pageNumber: page,
            // },
          })
          .then((r) => {
            this.$data.cat = Object.assign({}, r.data.data);
            this.$data.displayImage = r.data.data.image;
            this.searchData();
            this.$vs.loading.close();
            // if (!r.data.status) {
            //   this.$vs.notify({
            //     title: "Error",
            //     text: r.data.error,
            //     color: "danger",
            //     position: "top-right",
            //   });
            // }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    copyGuid(guid) {
      var input_temp = document.createElement("input");
      input_temp.value = guid;
      document.body.appendChild(input_temp);
      input_temp.select();
      document.execCommand("copy");
      document.body.removeChild(input_temp);
      this.$vs.notify({
        text: "GUID copied",
        color: "success",
        position: "top-right",
      });
    },
    viewAll(i) {
      this.$router.push("/articles/?catid=" + i._id + "&catLang=" + i.language);
    },
    disableCategory(id) {
      console.warn(id);
    },
    updateStatus(id, data) {
      console.warn(id);
      console.warn(data);

      // this.$data.disableCategoryPopup = true;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      api
        .put(API.ARTICLE_CATEGORY + "/disable" + "?id=" + id, { status: data }, { headers })
        .then((r) => {
          this.$vs.loading.close();
          this.searchData();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    if (this.$data.search.language) {
      this.$data.search.language = this.$route.query.catLang;
    }
    // this.searchData();
    this.fetchAllLanguages();
    if (!this.$data.search.language) {
      this.$data.search.language = "EN";
    }
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
